import { v4 as uuidv4 } from 'uuid';

export class Guid {
  static newGuid(): string {
    return uuidv4();
  }

  static empty = '00000000-0000-0000-0000-000000000000';
}
